import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import WorkerLoadListAnalysisReportActions, {
  WorkerLoadListAnalysisReportTypes
} from '../Stores/WorkerLoadListAnalysisReport/Actions';

const getAppStore = state => state.app;

export function* workerLoadListAnalysisReportInitWorkerLoadListAnalysis() {
  try {
    yield put(WorkerLoadListAnalysisReportActions.workerLoadListAnalysisReportReportLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `workerReport/initWorkerLoadListAnalysis/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        WorkerLoadListAnalysisReportActions.workerLoadListAnalysisReportInitWorkerLoadListAnalysisSuccess(
          result.data
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(WorkerLoadListAnalysisReportActions.workerLoadListAnalysisReportReportLoading(false));
  }
}

export function* workerLoadListAnalysisReportWorkerLoadListAnalysis({ formikBag, criteria }) {
  try {
    formikBag.setSubmitting(true);
    yield put(WorkerLoadListAnalysisReportActions.workerLoadListAnalysisReportReportLoading(true));

    const objCriteria = {};
    if ('start_date' in criteria) {
      objCriteria.start_date = criteria.start_date;
    }
    if ('end_date' in criteria) {
      objCriteria.end_date = criteria.end_date;
    }
    if ('user_ids_select2' in criteria) {
      const values = criteria.user_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.user_ids = values.map(entry => {
          return entry.value;
        });
      }
    }

    let columns = [];
    if (criteria.columns.target.length > 0) {
      columns = criteria.columns.target.map(entry => {
        return entry.column;
      });
    }

    const app = yield select(getAppStore);
    const postData = {
      sorts: [],
      criteria: objCriteria,
      columns
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `workerReport/workerLoadListAnalysis/${app.curSiteFlowId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(
        WorkerLoadListAnalysisReportActions.workerLoadListAnalysisReportWorkerLoadListAnalysisSuccess(
          criteria,
          result.data.data
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
    yield put(WorkerLoadListAnalysisReportActions.workerLoadListAnalysisReportReportLoading(false));
  }
}

export function* workerLoadListAnalysisReportFetchUserOptions({ search }) {
  try {
    yield put(
      WorkerLoadListAnalysisReportActions.workerLoadListAnalysisReportFetchUserOptionLoading(true)
    );

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `user/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.username} ${d.first_name} ${d.last_name}`
      }));

      yield put(
        WorkerLoadListAnalysisReportActions.workerLoadListAnalysisReportFetchUserOptionSuccess(
          options
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      WorkerLoadListAnalysisReportActions.workerLoadListAnalysisReportFetchUserOptionLoading(false)
    );
  }
}

export const saga = [
  takeLatest(
    WorkerLoadListAnalysisReportTypes.WORKER_LOAD_LIST_ANALYSIS_REPORT_INIT_WORKER_LOAD_LIST_ANALYSIS,
    workerLoadListAnalysisReportInitWorkerLoadListAnalysis
  ),
  takeLatest(
    WorkerLoadListAnalysisReportTypes.WORKER_LOAD_LIST_ANALYSIS_REPORT_WORKER_LOAD_LIST_ANALYSIS,
    workerLoadListAnalysisReportWorkerLoadListAnalysis
  ),
  takeLatest(
    WorkerLoadListAnalysisReportTypes.WORKER_LOAD_LIST_ANALYSIS_REPORT_FETCH_USER_OPTIONS,
    workerLoadListAnalysisReportFetchUserOptions
  )
];
